import React from 'react'
import styles from './HomeServicesSection.module.css'

/* Swap each `image` with your own (R2 / CDN / local import).
   Or pass the array as a prop: <HomeServicesSection services={...} /> */
const SERVICES = [
  {
    title: 'MICE & Conferences',
    desc: 'Annual meetings, conferences, exhibitions, and product launches delivered with operational precision and creative ambition.',
    tags: ['Annual Meetings', 'Exhibitions', 'Product Launches'],
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1300&q=80',
    href: '#contact',
  },
  {
    title: 'Award Nights & Engagement',
    desc: 'Stage production, employee engagement, and celebratory experiences that build culture and connection across your organisation.',
    tags: ['Stage Production', 'Employee Engagement', 'Training'],
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1300&q=80',
    href: '#contact',
  },
  {
    title: 'Strategic Consulting',
    desc: 'Tailored strategies, risk analysis, and cost-benefit modelling — backed by a culture of continuous improvement.',
    tags: ['Strategy', 'Risk Analysis', 'Cost-Benefit Modelling'],
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1300&q=80',
    href: '#contact',
  },
  {
    title: 'Group Travel & Off-sites',
    desc: 'End-to-end logistics for leadership off-sites, incentive travel, and global team gatherings — from itinerary to on-ground delivery.',
    tags: ['Leadership Off-sites', 'Incentive Travel', 'Global Gatherings'],
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1300&q=80',
    href: '#contact',
  },
]

const HomeServicesSection = ({ services = SERVICES }) => {
  return (
    <section id="services" className={styles.section}>
      <div className={styles.container}>
        <header className={styles.head}>
          <span className={styles.eyebrow}>Capabilities</span>
          <h2 className={styles.heading}>A complete experience studio</h2>
          <p className={styles.lead}>
            Four disciplines, one team — from the first strategy session to the
            final stage cue.
          </p>
        </header>

        <div className={styles.rows}>
          {services.map((s, i) => (
            <article key={s.title} className={styles.row}>
              <div className={styles.media}>
                <img src={s.image} alt={s.title} className={styles.image} />
              </div>

              <div className={styles.body}>
                <span className={styles.index}>0{i + 1}</span>
                <h3 className={styles.rowTitle}>{s.title}</h3>
                <p className={styles.rowDesc}>{s.desc}</p>

                <ul className={styles.tags}>
                  {s.tags.map((t) => (
                    <li key={t} className={styles.tag}>{t}</li>
                  ))}
                </ul>

                <a href={s.href} className={styles.link}>
                  Start a conversation
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HomeServicesSection